/** @format */

import axios from 'axios';

import { notification } from 'antd';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';

import { Loading } from '../../../components/Loading';
import { Response } from '../../../components/Response';

import { ENV_COUNTRY, ENV_FUNCTION_PANEL_TRACKING } from '../../../hooks/enviroment';

export async function servicesResendPos(item) {
	const userData = GetLocalStorageValue(LOCAL_STORAGE.USER);
	Loading.open();
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_PANEL_TRACKING}/status/resend-pos/${ENV_COUNTRY}`,
		data: {
			trx_id: item.trx_id,
			email: `${userData.email}`,
			pharmacy: item.pharmacy,
		},
	})
		.then(async (response) => {
			Loading.close();
			Response.open(response.data, 'aproved-qf');
			return response.data;
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_PANEL_TRACKING}/status/resend-pos/${ENV_COUNTRY}`,
			});
			return error.response.data;
		});
}
